import { Loader2 } from "lucide-react";

export const Loader = ({ label = "Unrolling the scrolls..." }) => (
  <div data-testid="loader" className="min-h-[60vh] flex flex-col items-center justify-center gap-3 text-slate-400">
    <Loader2 className="w-6 h-6 animate-spin text-amber-500" />
    <span className="font-display italic text-lg">{label}</span>
  </div>
);
